/* G Dash (#obshrine): a button link to #<section ID> scrolls smoothly to that section, above or below, stopping clear of
   the sticky header. The ID is Shrine Pro's own ("Display section ID": #shopify-section-<id>); a section's own key (#offers)
   and an empty anchor inside a section (the Offers section's #offers) lead to it too. */
(function () {
  if (window.__gdSectionLinks) return;
  window.__gdSectionLinks = true;
  var GAP = 12;
  function still() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  function bare(hash) {
    var h = String(hash || '').replace(/^#/, '');
    try { return decodeURIComponent(h); } catch (e) { return h; }
  }
  function sectionOf(el) {
    return (el && el.closest && el.closest('.shopify-section')) || el;
  }
  function find(hash) {
    var id = bare(hash);
    if (!id) return null;
    var el = document.getElementById(id);
    if (el && (el.classList.contains('shopify-section') || (!el.children.length && !String(el.textContent || '').trim())))
      return sectionOf(el);
    el = document.getElementById('shopify-section-' + id);
    if (el) return el;
    var secs = document.querySelectorAll('.shopify-section[id^="shopify-section-"]'), lead = [];
    for (var i = 0; i < secs.length; i++) {
      var key = secs[i].id.slice(16).split('__').pop();
      if (key === id) return secs[i];
      if (key.indexOf(id) === 0) lead.push(secs[i]);
    }
    if (lead.length === 1) return lead[0];
    if (/^offer/i.test(id)) {       // the theme's own Offers section left out (for the bundle app): its links go to the buy area
      var forms = document.querySelectorAll('.shopify-section form[action*="/cart/add"]');
      for (var j = 0; j < forms.length; j++) {
        var s = sectionOf(forms[j]);
        if (s && s.offsetParent !== null && !(s.closest('.shopify-section-group-header-group, .shopify-section-group-footer-group')))
          return s;
      }
    }
    return null;
  }
  function pinned() {
    var bottom = 0;
    var els = document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-header-sticky, sticky-header');
    for (var i = 0; i < els.length; i++) {
      var cs = window.getComputedStyle(els[i]);
      if ((cs.position !== 'sticky' && cs.position !== 'fixed') || cs.display === 'none' || cs.visibility === 'hidden') continue;
      var r = els[i].getBoundingClientRect();
      if (!r.height) continue;
      bottom = Math.max(bottom, Math.max(0, parseFloat(cs.top) || 0) + r.height);
    }
    return bottom;
  }
  function spot(t) {
    return Math.max(0, Math.round(t.getBoundingClientRect().top + window.pageYOffset - pinned() - GAP));
  }
  // #obtheme2: what loads on the way (a lazy picture, a video) moves the section after the scroll was aimed, and the browser's own
  // scroll anchoring moves the page with it, so the end is never compared with the aim: each time the page stops, it is put on
  // the section. Once it has arrived, a page that moves again was scrolled (by him or the page's own code) and is left alone; a
  // section that moves while the page stays (something above it loading) is followed, until it has rested 1.5 s (6 s at most).
  // Pressing, scrolling or typing ends it at once.
  var gen = 0, userAt = 0;
  ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) {
    window.addEventListener(ev, function () { userAt = Date.now(); }, { passive: true, capture: true });
  });
  function go(t, smooth) {
    var how = smooth && !still() ? 'smooth' : 'instant', mine = ++gen, start = Date.now(), last = -1, rest = 0, fixes = 0,
      good = 0, arrived = false;
    window.scrollTo({ top: spot(t), behavior: how });
    function tick() {
      if (mine !== gen || userAt > start) return;
      var y = window.pageYOffset;
      if (y !== last) {
        if (arrived) return;
        last = y; rest = 0;
      } else if (++rest >= 2) {
        var want = Math.min(spot(t), document.documentElement.scrollHeight - window.innerHeight);
        if (Math.abs(want - y) > 3) {
          if (fixes++ >= 6) return;
          window.scrollTo({ top: want, behavior: 'instant' });
          last = window.pageYOffset; rest = 0; good = 0;
        } else {
          arrived = true;
          if (++good >= 12) return;
        }
      }
      if (Date.now() - start < 6000) setTimeout(tick, 120);
    }
    setTimeout(tick, 120);
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
    if (!a || a.matches('[role="tab"], [aria-controls], [data-no-section-link], .skip-to-content-link')) return;
    var raw = a.getAttribute('href') || '', u;
    try { u = new URL(raw, window.location.href); } catch (er) { return; }
    var here = raw.charAt(0) === '#' ||
      (u.origin === window.location.origin && u.pathname === window.location.pathname && u.search === window.location.search);
    if (!here || !u.hash || u.hash === '#') return;
    var t = find(u.hash);
    if (!t) return;
    e.preventDefault();
    go(t, true);
    try { window.history.replaceState(window.history.state, '', u.hash); } catch (er) {}
  }, true);
  function arrive() {
    var t = window.location.hash && find(window.location.hash);
    if (t) go(t, false);
  }
  if (document.readyState === 'complete') setTimeout(arrive, 0);
  else window.addEventListener('load', function () { setTimeout(arrive, 0); });
  window.gdSectionFind = find;
})();
